import React from 'react';
import PropTypes from 'prop-types';
import {
  BottomNavigation,
  BottomNavigationAction,
  Tooltip,
} from '@material-ui/core';

const RefundTabs = ({
  navTypes,
  tab,
  tanOnChange,
}) => (
  <div className="d-flex flex-column align-items-center">
    <span className="font-size-12">Tipo de devolución:</span>
    <BottomNavigation
      value={tab}
      onChange={tanOnChange}
      showLabels
      className="refund_tabs"
    >
      {navTypes.map((type, i) => (
        <Tooltip
          key={`key_refund_${type.label}`}
          title={type.tooltip}
          placement={i === 0
            ? ('left-start')
            : ('right-start')
          }
        >
          <BottomNavigationAction
            key={`key_refund_${type.label}`}
            icon={type.icon}
            label={type.label}
          />
        </Tooltip>
      ))}
    </BottomNavigation>
  </div>
);

RefundTabs.propTypes = {
  navTypes: PropTypes.array.isRequired,
  tab: PropTypes.number.isRequired,
  tanOnChange: PropTypes.func.isRequired,
};

export default RefundTabs;
